/* eslint-disable unused-imports/no-unused-vars */
import { Modal } from 'bootstrap/dist/js/bootstrap.esm.js'

export default defineNuxtPlugin(async (nuxtApp) => {
  window.__MODAL__ = Modal
})
